// Minimal cross-page legal footer. Shows on Pricing / Account / Terms /
// Privacy / Auth. Landing has its own larger footer with the same legal
// links, so it doesn't render this one.
//
// Keep this small — no styling beyond a thin top border and centered text.
// Order intentionally puts Terms + Privacy first (most-clicked legal links).

import { Link } from 'react-router-dom';
import { useT } from '../lib/i18n';
import './LegalFooter.css';

export function LegalFooter() {
  const t = useT();
  return (
    <footer className="legal-footer">
      <Link to="/terms">{t('nav.terms')}</Link>
      <span className="sep">·</span>
      <Link to="/privacy">{t('nav.privacy')}</Link>
      <span className="sep">·</span>
      <Link to="/pricing">{t('nav.pricing')}</Link>
      <span className="sep">·</span>
      <a href="mailto:codescao7@gmail.com">{t('nav.contact')}</a>
      <div className="legal-footer-meta muted">
        {t('footer.copyright')}
      </div>
    </footer>
  );
}
